const localeFR = {
  fr: {
    "ui-kit": {
      form: {
        stepper: {
          error: "A corriger",
          completed: "Complété",
          "select-step": "Changer d'étape",
          "step-progress": "Etape {index}/{total}",
          "to-complete": "A compléter"
        }
      }
    },
    uiKit: {
      switchDashboard: {
        title: {
          simulatorAccess: "Faire un  investissement rentable",
          simulationsAccess: "Passer en mode investisseur",
          accessToRealEstatesManagement: "Passer en mode gestionnaire",
          createFirstRealEstates: "Piloter ma gestion locative",
          homePage: {
            simulationsAccess: "Accéder à mes simulations",
            accessToRealEstatesManagement: "Gérer mes biens"
          }
        },
        subtitle: {
          simulationsRealised: "simulation réalisée | simulations réalisées",
          realEstateManaged: "bien géré | biens gérés"
        }
      },
      notifications: {
        title: "Notifications",
        label_new: "NOUVEAU",
        empty_list: "Pas de nouvelles notifications pour le moment",
        parameters: {
          button: "Paramètres",
          title: "Gestion des notifications",
          switch: {
            title: "Notifications navigateur",
            description: "Être alerté des événements importants sans être connecté à horiz.io"
          }
        },
        browserDenied: {
          browserHandled: {
            title: "Vous avez bloqué les notifications.",
            text: "Suivez les instructions ci-après pour autoriser les notifications ou",
            link: "consulter notre article d'aide."
          },
          browserNotHandled: {
            title: "Vos notifications sont bloquées.",
            text: "Pour autoriser les notifications,",
            link: "veuillez suivre les instructions de notre article d'aide."
          }
        }
      },
      menu: {
        "manage-profile": "Gérer mon profil",
        "bank-sync": "Synchro bancaire",
        "manage-subscription": "Mon abonnement",
        "my-incomes": "Mes revenus",
        "consult-experts": "Consulter des Experts",
        marketplace: "Marketplace",
        suggestions: "Suggestions d’amélioration",
        "help-and-contact": "Aide et contact",
        "in-trial": "Actuellement en période d'essai",
        subscribe: "Souscrire",
        logout: "Déconnexion",
        icon: {
          close: "Fermer"
        }
      },
      validation: {
        rules: {
          "a-city": "une ville",
          beforeToday: "La date de début doit être antérieure à la date du jour",
          email: "Cette adresse mail est invalide.",
          min: "{length} caractères en tout",
          required: "Ce champ est obligatoire.",
          "valid-city-postal-code": "Veuillez sélectionner une ville dans la liste",
          in: "Veuillez sélectionner {_field_} dans la liste",
          "email-already-exist": "Cette adresse email existe déjà",
          "email-or-username": "Adresse email incorrecte",
          password: "Votre mot de passe doit contenir : au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial",
          "password-different": "Les champs mot de passe/confirmation du mot de passe ne correspondent pas.",
          "wrong-current-password": "Le mot de passe actuel ne correspond pas",
          "old-password-equals-new": "Vous utilisez déjà ce mot de passe",
          "unknown-update-password-error": "Impossible de mettre à jour le mot de passe",
          minOneUppercase: "une majuscule",
          minOneLowercase: "une minuscule",
          minOneSpecialCharacter: "un caractère spécial parmi : @ # $ ! % * ? & . , ; / :",
          minOneNumber: "un chiffre",
          "property-address": "Merci de sélectionner une adresse dans la liste proposée. Si votre adresse n'apparaît pas, utilisez une autre adresse proche (nom de la rue principale voisine). Vous pourrez la modifier plus tard pour améliorer sa précision.",
          "property-address-try-guess-postal-code": "Merci de sélectionner une adresse dans la liste proposée. Si votre adresse n'apparaît pas, utilisez une autre adresse proche (nom de la rue principale voisine). Vous pourrez la modifier plus tard pour améliorer sa précision.",
          "basic-fr-date": "Date incorrecte",
          "email-exist": "Cette adresse email/pseudo existe déjà",
          phone: "Numéro de téléphone incorrect",
          biggerthan: "La valeur saisie doit être supérieure à {min}",
          lowerOrEqual: "La valeur saisie doit être inférieure ou égale à {max}",
          biggerOrEqual: "La valeur saisie doit être supérieure ou égale à {min}",
          year: "Le champs année doit être composé de quatre chiffres",
          selectRequired: "Ce champ est obligatoire.",
          siret: "SIRET incorrect",
          siren: "SIREN incorrect",
          postalCode: "Code postal incorrect",
          isEmailList: "Email invalide(s)",
          url: "URL invalide",
          phoneNumber: "Numéro de téléphone invalide"
        }
      }
    }
  }
};
export {
  localeFR as default
};
//# sourceMappingURL=fr.es.js.map
